module.exports = __webpack_public_path__ + "static/media/ploni-ultralight-aaa.d87b32bb.woff2";